export default "__VITE_ASSET__DTpSB0S$__"